const MONDAY = '1'
const TUESDAY = '2'
const WEDNESDAY = '3'
const THURSDAY = '4'
const FRIDAY = '5'
const SATURDAY = '6'
const SUNDAY = '7'

export const BRIEF_TYPE = {
  SEARCH: 1,
  NETWORK: 2,
  SOCIAL: 4
}

export const WEEK_DAYS = `${MONDAY},${TUESDAY},${WEDNESDAY},${THURSDAY},${FRIDAY}`

export const GENDER_ANY = 'm,f'
const GENDER_MALE = 'm'
const GENDER_FEMALE = 'f'

const AGE_ONE = '18-24'
const AGE_TWO = '25-34'
const AGE_THREE = '35-44'
const AGE_FOUR = '45+'

const LABEL_DAYS = {
  [MONDAY]: 'Brief.day.monday',
  [TUESDAY]: 'Brief.day.tuesday',
  [WEDNESDAY]: 'Brief.day.wednesday',
  [THURSDAY]: 'Brief.day.thursday',
  [FRIDAY]: 'Brief.day.friday',
  [SATURDAY]: 'Brief.day.saturday',
  [SUNDAY]: 'Brief.day.sunday'
}

const LABEL_GENDERS = {
  [GENDER_ANY]: 'Brief.gender.any',
  [GENDER_MALE]: 'Brief.gender.male',
  [GENDER_FEMALE]: 'Brief.gender.female'
}

export const GENDERS = [
  {
    label: LABEL_GENDERS[GENDER_ANY],
    value: GENDER_ANY
  },
  {
    label: LABEL_GENDERS[GENDER_MALE],
    value: GENDER_MALE
  },
  {
    label: LABEL_GENDERS[GENDER_FEMALE],
    value: GENDER_FEMALE
  }
]

export const AGES = [
  {
    label: 'Brief.are.range.one',
    value: AGE_ONE
  },
  {
    label: 'Brief.are.range.two',
    value: AGE_TWO
  },
  {
    label: 'Brief.are.range.three',
    value: AGE_THREE
  },
  {
    label: 'Brief.are.range.four',
    value: AGE_FOUR
  }
]

export const WORKING_DAYS = [
  {
    label: LABEL_DAYS[MONDAY],
    value: MONDAY
  },
  {
    label: LABEL_DAYS[TUESDAY],
    value: TUESDAY
  },
  {
    label: LABEL_DAYS[WEDNESDAY],
    value: WEDNESDAY
  },
  {
    label: LABEL_DAYS[THURSDAY],
    value: THURSDAY
  },
  {
    label: LABEL_DAYS[FRIDAY],
    value: FRIDAY
  },
  {
    label: LABEL_DAYS[SATURDAY],
    value: SATURDAY
  },
  {
    label: LABEL_DAYS[SUNDAY],
    value: SUNDAY
  }
]

export const HOURS = [
  '00:00',
  '01:00',
  '02:00',
  '03:00',
  '04:00',
  '05:00',
  '06:00',
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00'
]

export const ADVANTAGES_MAX_LENGTH = 20
export const ACTION_MAX_LENGTH = 30

// analytics
export const BRIEF_CREATE_START_FILLING = 'brief_create_rus_start_filling'
export const BRIEF_CREATE_EVENT = 'form_brief_create_rus'
